import React from 'react';
import { Heart, Github, Mail, Globe, BookOpen, Globe2 } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-emerald-600 mb-2">ھەققىدە</h1>
          <p className="text-gray-600 uyghur-text">ئۇيغۇرچە سۆز زەنجىرى ئويۇنى ھەققىدە</p>
        </div>
        
        <div className="game-card mb-6">
          <h2 className="text-xl font-semibold mb-4 uyghur-text">ئويۇن ھەققىدە</h2>
          <p className="mb-4 text-gray-700 uyghur-text">
            ئۇيغۇرچە سۆز زەنجىرى ئويۇنى — ئۇيغۇر تىلىدىكى سۆزلەرنى ئۆگىنىش ۋە مەشىق قىلىش ئۈچۈن ياسالغان بىر كۆڭۈللۈك ئويۇن. بۇ ئويۇندا ئىشلىتىلگەن سۆزلۈك 35,000 دىن ئارتۇق ئۇيغۇرچە سۆزنى ئۆز ئىچىگە ئالىدۇ.
          </p>
          <p className="mb-4 text-gray-700 uyghur-text">
            بۇ ئويۇن بالىلارنىڭ ئۇيغۇر تىلىنى ئۆگىنىشى، سۆز بايلىقىنى ئاشۇرۇشى ۋە ئۇيغۇر تىلىغا بولغان قىزىقىشىنى كۈچەيتىشى ئۈچۈن ياسالغان. شۇنداقلا چوڭلارمۇ بۇ ئويۇندىن بەھرىمەن بولۇپ، ئۆزىنىڭ ئۇيغۇرچە سۆز بايلىقىنى سىناپ كۆرەلەيدۇ.
          </p>
          <div className="flex items-center justify-center mb-4">
            <Heart size={24} className="text-red-500 mr-2" />
            <span className="uyghur-text text-gray-600">ئۇيغۇرچە سۆزلەرنى ئۆگىنىش ئۈچۈن ياسالغان</span>
          </div>
        </div>
        
        <div className="game-card mb-6">
          <h2 className="text-xl font-semibold mb-4 uyghur-text"> سۆزلۈك مەنبەسى ھەققىدە   </h2>
          <p className="mb-4 text-gray-700 uyghur-text">
          <a href="https://github.com/uyghur-language/uyghur-words" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-600 hover:text-emerald-600 transition-colors">
          <Github size={20} />
              <span>GitHub</span>
              <p>ئۇيغۇر سۆزلۈكلەر مەنبەسى</p>
            </a>
            سۆزلۈك مەنبەسى Githubتىن ئېلىنغان بولۇپ ئەگەر سىزدە ئەڭ يېڭى سۆزلۈكلەر بولسا تەمىنلىسىڭىز ساندانغا قوشۇپ قويىمىز رەھمەت
          </p>
          <p className="mb-4 text-gray-700 uyghur-text">
          </p>
         
        </div>
        
        <div className="game-card">
          <h2 className="text-xl font-semibold mb-4 uyghur-text"> مەنبە ۋە ئالاقە </h2>
          <h1 className='font-semibold mb-4 uyghur-text text-cyan-500'>ئەگەر سىزدە ئەڭ يېڭى سۆزلۈكلەر مەنبەسى بولسا تەمىنلىسىڭىز ساندانغا قوشۇپ قويىمىز رەھمەت</h1>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <a href="mailto:info@uyghurwordchain.com" className="flex items-center gap-2 text-gray-600 hover:text-emerald-600 transition-colors">
              <Mail size={20} />
              <span>applirim@gmail.com</span>
            </a>
            <a href="https://uyghurai.vercel.app/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-600 hover:text-emerald-600 transition-colors">
              <Globe2 size={20} />
              <span>UyghurAI</span>
              <p>  تور بېتىمىز</p>
            </a>
            <a href="https://zenjirsoz.vercel.app" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-600 hover:text-emerald-600 transition-colors">
              <Globe size={20} />
              <span>https://zenjirsoz.vercel.app</span>
            </a>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;